export default function SummaryPartError({ leaving, type }: { leaving: boolean; type: string }) {
  /// #if _DEBUG
  return (
    <div
      className={`SummaryPartError w-full relative z-2 ${leaving ? 'transition-opacity duration-500 ease-out-quad opacity-0' : '0'}`}
    >
      <h2 className='text-heading-h4 text-center text-scarlet'>Error - {type}</h2>
    </div>
  )
  /// #endif

  return null
}
